import { Alert, CircularProgress } from '@mui/material';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { getStandardTasks } from '@/features/settings/api/tasks';
import { StandardTasksGrid } from '@/features/settings/components/StandardTasksGrid';

export function StandardTasksPanel() {
  const client = useQueryClient();
  const query = useQuery({ queryKey: ['settings', 'tasks'], queryFn: getStandardTasks });
  if (query.isPending)
    return <CircularProgress aria-label="Loading standard tasks" sx={{ m: 2 }} />;
  if (query.isError)
    return (
      <Alert severity="error">Standard tasks could not be loaded. Refresh to try again.</Alert>
    );
  return (
    <StandardTasksGrid
      key={query.data ?? 'empty'}
      checklist={query.data}
      onSaved={(tasks) => client.setQueryData(['settings', 'tasks'], JSON.stringify(tasks))}
    />
  );
}
